export default "__VITE_ASSET__5a0eef39__"